import type {
    CustomComponentField,
    CustomDisplayField,
    CustomValueField,
    CustomFieldTypeIdField,
    RecordDetailField,
    GridFieldDetailField,
    CustomComponentDetailField,
    CustomValueDetailField
} from './types';
import {exists} from 'shared/utils/custom-utils';

// Utils for CustomDisplayField
export function isCustomComponentField(field: CustomDisplayField): field is CustomComponentField {
    return (
        exists(field) &&
        typeof field === 'object' &&
        'component' in field &&
        exists(field.component)
    );
}

export function isCustomValueField(field: CustomDisplayField): field is CustomValueField {
    return (
        exists(field) &&
        typeof field === 'object' &&
        'value' in field
    );
}

export function isCustomFieldTypeIdField(field: CustomDisplayField): field is CustomFieldTypeIdField {
    return typeof field === 'string';
}

export function isValidCustomDisplayField(field: CustomDisplayField): boolean {
    return isCustomComponentField(field) || isCustomValueField(field) || isCustomFieldTypeIdField(field);
}

// Utils for RecordDetailField
export function isGridFieldDetailField(field: RecordDetailField): field is GridFieldDetailField {
    return (
        exists(field) &&
        'field' in field &&
        'definition' in field
    );
}

export function isCustomComponentDetailField(field: RecordDetailField): field is CustomComponentDetailField {
    return (
        exists(field) &&
        'component' in field &&
        exists(field.component)
    );
}

export function isCustomValueDetailField(field: RecordDetailField): field is CustomValueDetailField {
    return (
        exists(field) &&
        'value' in field
    );
}

export function isValidRecordDetailField(field: RecordDetailField): boolean {
    return isGridFieldDetailField(field) || isCustomComponentDetailField(field) || isCustomValueDetailField(field);
}